<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">{{title}}</h2>
      <a href="javascript:;" v-if="contractId" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <el-form-item label="需求单位">
            <!-- <el-input size="small" :disabled="true" v-model="contractId ? contract.departmentVO.name : userData.department.split('/')[0]"></el-input> -->
            <el-select @change="forceUpdate" size="small" :disabled="noSelectOrganization"
              class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
              <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="clear">
            <el-col :span="12">
              <el-form-item label="合同负责人">
                <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input size="small" :disabled="true" v-model="userData.mobile"></el-input>
              </el-form-item>
            </el-col>
          </div>
          <el-form-item label="合同名称">
            <el-col :span="10">
              <el-input size="small" placeholder="请输入合同名称" v-model="form.name"></el-input>
            </el-col>
          </el-form-item>
          <el-col :span="20">
            <el-form-item label="合同概要">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" size="small" placeholder="请输入合同概要"
                v-model="form.outline"></el-input>
            </el-form-item>
            <el-form-item label="是否招标">
              <el-radio v-model="form.isZb" label="1">是</el-radio>
              <el-radio v-model="form.isZb" label="0">否</el-radio>
            </el-form-item>


            <el-form-item label="关联工程(选填)">
              <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.projectIds"
                filterable multiple placeholder="请选择">
                <el-option v-for="item in projectList" :key="item.id" :label="item.number+'-'+item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="关联采购(选填)">
              <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.purchaseIds"
                filterable multiple placeholder="请选择">
                <el-option v-for="item in purchaseList" :key="item.itemId" :label="item.number+'-'+item.name"
                  :value="item.itemId">
                </el-option>
              </el-select>
            </el-form-item>

            <div class="clear">
              <el-col :span="12">
                <el-form-item label="是否重大合同">
                  <el-radio v-model="form.isBigContract" label="1">是</el-radio>
                  <el-radio v-model="form.isBigContract" label="0">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否大客户">
                  <el-radio v-model="form.isBigCustomer" label="1">是</el-radio>
                  <el-radio v-model="form.isBigCustomer" label="0">否</el-radio>
                </el-form-item>
              </el-col>
            </div>

            <el-form-item label="">
              <el-button :loading="formLoading" @click="submitForm()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-col>


        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    components: {

    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,

        depId: "",
        form: {
          depId: "",
          name: "",
          outline: "",
          isBigContract: "0",
          isBigCustomer: "0",
          isZb: "0",
          projectIds: "",
          projectNames: "",
          purchaseIds: "",
          purchaseNames: "",
          type: 0,
        },

        // 选择项目列表
        projectList: [],
        // 选择采购申请列表
        purchaseList: [],

        // loading状态
        formLoading: false,

        // edit
        title: '新建合同',
        contractId: 0,
        contract: '',
      }
    },
    created() {
      // 从项目过来的关联项目
      let objectId = this.$route.params.objectId
      if (objectId) {
        this.form.projectIds = objectId.split(",").map(Number)
      }

      this.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.depId == "7") {
        this.noSelectOrganization = false
      }
      console.log(this.depId)

      // 获取项目列表
      this.getProjectList(() => {
        // 获取采购列表
        this.getPurchaseList(() => {
          // 项目列表和采购列表加载成功后操作
          this.contractId = this.$route.params.id
          if (!this.contractId) {
            this.form.depId = this.depId
          } else {
            this.title = '编辑合同'
            this.form.contractId = this.contractId
            this.getcontractDetail()
          }

        })
      })
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取合同详情
      getcontractDetail() {
        ajax.get("/contract/info/" + this.contractId, "", (res) => {
          this.contract = res.vo
          let contract = res.vo

          this.form.depId = contract.departmentVO.id
          this.form.name = contract.name
          this.form.outline = contract.outline
          this.form.isBigContract = contract.isBigContract ? '1' : '0'
          this.form.isBigCustomer = contract.isBigCustomer ? '1' : '0'
          this.form.isZb = contract.isZb ? '1' : '0'
          if (contract.projectIds) {
            this.form.projectIds = contract.projectIds.split(",").map(Number)
          }
          if (contract.purchaseIds) {
            this.form.purchaseIds = contract.purchaseIds.split(",").map(Number)
          }
        })
      },

      // 获取采购列表
      getPurchaseList(cb) {
        ajax.get('/contract/purchase/choose/list', {
          depId: this.depId
        }, (res) => {
          this.purchaseList = res.vo.array
          cb && cb()
        })
      },
      // 获取项目列表
      getProjectList(cb) {
        ajax.get('/contract/project/choose/list', {
          depId: ''
        }, (res) => {
          this.projectList = res.vo.array
          cb && cb()
        })
      },
      // 通过项目ID获取Name
      getProjectNameById() {
        let name = []
        for (let i = 0; i < this.form.projectIds.length; i++) {
          let _id = this.form.projectIds[i]
          for (let j = 0; j < this.projectList.length; j++) {
            if (this.projectList[j].id == _id) {
              name.push(this.projectList[j].name)
              break
            }
          }
        }
        return name.join(",")
      },
      // 通过采购ID获取Name
      getPurchaseNameById() {
        let name = []
        for (let i = 0; i < this.form.purchaseIds.length; i++) {
          let _id = this.form.purchaseIds[i]
          for (let j = 0; j < this.purchaseList.length; j++) {
            if (this.purchaseList[j].itemId == _id) {
              name.push(this.purchaseList[j].name)
              break
            }
          }
        }
        return name.join(",")
      },

      // 提交合同
      submitForm() {
        // 工程
        this.form.projectNames = this.getProjectNameById()
        this.form.projectIds = this.form.projectIds ? this.form.projectIds.join(",") : ''
        // 采购
        this.form.purchaseNames = this.getPurchaseNameById()
        this.form.purchaseIds = this.form.purchaseIds ? this.form.purchaseIds.join(",") : ''

        if (!this.form.depId || !this.form.name || !this.form.outline) {
          this.$message.error('合同名称，合同简介均不能为空')
          return
        }

        this.formLoading = true
        let _url = this.contractId ? '/contract/edit' : '/contract/add'
        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.$message.success(this.title + "成功")
          if (this.contractId) {
            this.$router.back()
          } else {
            this.$router.push("/Contract/Detail/" + res.vo.id)
          }
        })
      },
    },
    watch: {
      "$route"() {
        this.hasApplyId = this.$route.params.applyId ? true : false
      }
    },
  };
</script>


// WEBPACK FOOTER //
// src/page/contract/create.vue